<template>
  <!-- Calendar HTML -->
  <div class="mx-auto calendar-box">
    <v-overlay absolute color="white" opacity="0.8" :value="loading">
      <div class="flex flex-col justify-center items-center mx-auto">
        <v-progress-circular
        indeterminate
        color="secondary"
        :size="loaderSize"
        :width="loaderStroke"
        ></v-progress-circular>
        <p v-if="!isPackFlight" class="py-4 text-lg lg:text-xl font-black text-black text-center w-64">{{ $t("wizard_more_days.searching_flights") }}</p>
        <p v-else class="py-4 text-lg lg:text-xl font-black text-black text-center w-64">{{ $t("wizard_shared.searching_flights") }}</p>
      </div>
    </v-overlay>
    <div class="prev-next-month-container flex justify-between items-center px-4">
      <div class="flex w-full justify-start items-center">
        <button type="button" id="previousBtn" class="arrow-btn-calendar focus:outline-none">
          <img class="mb-1" src="/img/icons/navigate_before-black-18dp.svg" alt />
        </button>
        <h3 class="w-full lg:w-100 outgoing-text-align font-bold lg:ml-5" id="monthAndYearLeft"></h3>
      </div>
      <div class="flex lg:w-full justify-end items-center" :class="{ 'button-right-div': single }">
        <h3 class="w-100 text-center card-header font-bold hidden lg:block lg:mr-5" id="monthAndYearRight" :class="{ single: single }"></h3>
        <button id="nextBtn" type="button" class="arrow-btn-calendar focus:outline-none">
          <img class="mb-1" src="/img/icons/navigate_next-black-18dp.svg" alt />
        </button>
      </div>
    </div>
    <div id="calendar-tables-container" class="flex flex-row justify-center">
      <div class="width-mobile lg:w-1/2 lg:mr-4">
        <table class="table-auto w-full heading">
          <hr class="line" />
          <thead>
            <tr>
              <th
                v-for="(day, index) in daysOfWeek[lang]"
                :key="index"
                class="days"
              >
                {{ day }}
              </th>
            </tr>
          </thead>
        </table>
        <table
          class="table-auto w-full"
          :class="{ 'full-width': single, loading }"
          id="calendar-1"
        >
          <tbody id="calendar-body-1" class="table-calendar"></tbody>
        </table>
      </div>
      <div class="lg:w-1/2 hidden lg:block w-1/2 lg:ml-4">
        <table class="table-auto w-full heading">
          <hr class="line" />
          <thead>
            <tr>
              <th
                v-for="(day, index) in daysOfWeek[lang]"
                :key="index"
                class="days"
              >
                {{ day }}
              </th>
            </tr>
          </thead>
        </table>
        <table
          class="table-auto w-full"
          :class="{ single: single }"
          id="calendar-2"
        >
          <tbody id="calendar-body-2" class="table-calendar"></tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import loadCalendar from "./index";
import { daysOfTheWeek } from '../../utils/trans';

export default {
  props: {
    single: {
      type: Boolean,
      default: false,
    },
    daysToAvaliableCalendar: {
      type: Number,
      default: 1,
    },
    duration: {
      type: Number,
      default: 1,
    },
    getCalendar: {
      type: Object,
      default: () => {
        return {
          currentMonth: new Date().getMonth(),
          currentYear: new Date().getFullYear(),
        };
      },
    },
    date: {
      type: Object,
      default: () => {
        return {
          from: new Date("2024-01-01"),
          to: new Date("2024-01-01"),
        };
      },
    },
    days: {
      type: Array,
      default: () => [],
    },
    lang: {
      type: String,
      default: window.appLocale,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    isPackFlight:{
      type: Boolean,
      default: () => false,
    },
    daysSelectedLoading: {
      type: Array,
      default: () => [],
    },
    extraPrice: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    loaderSize() {
      return window.innerWidth >= 768 ? 85 : 50;
    },
    loaderStroke() {
      return window.innerWidth >= 768 ? 8 : 5;
    },
  },
  data: () => ({
    displayLoading: true,
    update: 0,
    daysOfWeek: daysOfTheWeek,
    dateSelected: null,
    currentMonthData: null,
    currentYearData: null,
  }),
  methods: {
    setDateSelected(dateFrom, dateTo, type, id) {
      this.dateSelected =dateFrom;
      this.$emit("date-selected", { dateFrom, dateTo, type, id });
    },
    setCalendarMethod(month, year) {
      this.currentMonthData = month;
      this.currentYearData = year;
      this.$emit("set-calendar", { month, year });
    },
  },
  watch: {
    loading: function (val) {
      loadCalendar(
        this.duration,
        this.days,
        this.daysToAvaliableCalendar,
        this.getCalendar.currentMonth,
        this.getCalendar.currentYear,
        this.date.from,
        this.setDateSelected,
        this.setCalendarMethod,
        true,
        false,
        this.extraPrice
      );
    },
    daysSelectedLoading: function (val) {
      if(val.length){
        loadCalendar(
          this.duration,
          this.days,
          this.daysToAvaliableCalendar,
          this.currentMonthData,
          this.currentYearData,
          this.dateSelected,
          this.setDateSelected,
          this.setCalendarMethod,
          true,
          true,
          this.extraPrice
        );
      }else{
        loadCalendar(
          this.duration,
          this.days,
          this.daysToAvaliableCalendar,
          this.currentMonthData,
          this.currentYearData,
          this.dateSelected,
          this.setDateSelected,
          this.setCalendarMethod,
          true,
          false,
          this.extraPrice
        );
      }
    },
  },
  mounted() {
    loadCalendar(
      this.duration,
      this.days,
      this.daysToAvaliableCalendar,
      this.getCalendar.currentMonth,
      this.getCalendar.currentYear,
      this.date.from,
      this.setDateSelected,
      this.setCalendarMethod,
      true,
      this.extraPrice
    );
  },
  created() {
    this.currentMonthData = this.getCalendar.currentMonth;
    this.currentYearData = this.getCalendar.currentYear;
  }
};
</script>

<style lang="scss">
@import "../../../sass/_variables";

.prev-next-month-container {
  padding-top: 1rem;
  margin-bottom: 0;
  @media (min-width: 1023px) {
    padding-top: 0;
    margin-bottom: -15px;
  }
  button {
    z-index: 1;
  }
}

//CustomCalendar
.line {
  border-bottom: 1px solid black;
  position: absolute;
  top: 60px;
  width: 93%;
}
.line-2 {
  border-bottom: 1px solid black;
  position: absolute;
  top: 60px;
  width: 96%;
  left: 10px;
}
.calendar-customized {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;

  @media (max-width: 768px) {
    justify-content: start !important;
  }

  @media (max-width: 1023px) {
    font-size: 0.9rem;
    padding-top: 40px;
  }
  @media (min-width: 1366px) {
    padding: 40px 0;
    min-height: calc(100vh - 64px);
  }
  .arrow-btn-calendar {
    border-radius: 10px;
    &:hover {
      background-color: rgb(167, 167, 167);
      border-radius: 10px;
    }
    img {
      width: 30px;
    }
  }

  table {
    position: relative;
    border-spacing: 24px 45px;
    border-collapse: separate;
    @media (max-width: 1279px) {
      border-spacing: 12px 45px;
    }
    @media (max-width: 1023px) {
      border-spacing: 6px 45px;
    }
    @media (max-width: 360px) {
      border-spacing: 5px 15px;
    }
    thead {
      tr {
        border-bottom: 1px solid black;
        border-collapse: unset;
      }
    }
    tbody {
      tr {
        height: 40px;
      }
    }
    &.heading {
      border-spacing: 24px 0;
      margin-bottom: 5px;
      margin-top: 25px;
      @media (max-width: 1279px) {
        border-spacing: 12px 0;
      }
      @media (max-width: 359px) {
        border-spacing: 7px 0;
      }
      tr {
        th {
          padding-bottom: 0;
        }
      }
      .line {
        top: 35px;
      }
    }
  }
  .calendar-box {
    position: relative;
    border-radius: 15px;
    border: solid 1px #979797;
    background-color: white;
    padding: 2rem;

    @media (max-width: 768px) {
      margin: .5rem !important;
    }
    @media (max-width: 1023px) {
      max-width: 400px;
      padding: 0 !important;
    }
    @media(max-width: 1024px){
      border: none;
      background-color: transparent;
      width: 100% !important;
    }

    @media (max-width: 1278px) {
      width: 85%;
      margin: auto;
    }

    @media (max-width: 1023px) {
      padding: 0.5rem 0.5rem 1rem;
    }
  }
  .single {
    display: none;
  }

  .button-right-div {
    width: 70px;
  }

  .full-width {
    width: 100%;
    margin-right: 0;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.3;
    background-color: transparent !important;
    color: black !important;
  }

  @media (max-width: 1279px) {
    .days,
    .cell {
      padding: 0.6rem;
    }
  }

  .days {
    padding: 0.5rem;
    height: 40px;
    min-width: 40px;
    font-weight: unset;

    @media (max-width: 1279px) {
      padding: 0rem;
      height: 32px;
      min-width: 32px;
    }
  }

  .cell {

    .loading {
      background-color: #e0e0e0;
      border-radius: 10px;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      display: block;

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: -150%;
        width: 150%;
        height: 100%;
        background: linear-gradient(to right, transparent 0%, #f0f0f0 50%, transparent 100%);
        animation: loading 1.5s infinite;
      }
    }

    @keyframes loading {
      0% {
        left: -150%;
      }
      50% {
        left: 100%;
      }
      100% {
        left: 100%;
      }
    }

    margin: 1rem;
    padding: 0;
    text-align: center;
    height: 40px;
    // width: 60px;
    position: relative;
    font-weight: 500;
    // background-color: transparent;
    color: black;
    background-origin: content-box;

    @each $type, $color in $selected-colors {
      &.#{$type}-before {
        background-color: $color;
        border-radius: 10px;
      }
    }
    @media (max-width: 1279px) {
      padding: 0.4rem;
      // height: 32px;
    }
    @media (max-width: 1024px) {
      padding: 0.6rem;
      // height: 32px;
    }

    &.disabled {
      color: lightgrey;
      pointer-events: none;
      &:before, &:after {
        content: "";
      }
    }

    &:before {
      position: absolute;
      width: 100%;
      display: flex;
      bottom: -20px;
      left: 0;
      height: 18px;
      // padding-bottom: 12px;
      z-index: 2;
      // font-family: $muli-font;
      font-size: 14px;
      // line-height: 11px;
      justify-content: center;
      content: attr(data-price);
      font-weight: 400;
      @media (max-width: 1279px) {
        bottom: -18px;
        font-size: 11px;
        height: 16px;
      }

    }

    &:after {
      position: absolute;
      width: 100%;
      display: flex;
      bottom: -40px;
      left: 0;
      height: 18px;
      z-index: 2;
      font-size: 11px;
      justify-content: center;
      content: attr(data-old-price);
      font-weight: 400;
      text-decoration: line-through;

      @media (max-width: 1279px) {
        bottom: -36px;
        font-size: 10px;
        height: 16px;
      }
    }

    @each $type, $color in $selected-colors {
      &.#{$type}-before {
        &:before {
          color: black;
          border-bottom-left-radius: 10px !important;
          border-bottom-right-radius: 10px !important;
        }
      }
    }

    @each $type, $color in $selected-colors {
      &.#{$type}-before {
        &:hover {
          background-color: #e6e8f4 !important;
          color: black;
          border-radius: 10px;
          border-bottom-left-radius: 10px !important;
          border-bottom-right-radius: 10px !important;
          &:before {
            // background-color: #e6e8f4!important;
          }
        }
      }
    }

    cursor: pointer;
    &:hover {
      background-color: #e6e8f4;
      border-radius: 10px;
    }

    &.selected {
      border-radius: 10px !important;
      background-color: #001d38 !important;
      color: white !important;
      opacity: 1;
      &:hover {
        background-color: #2a3f52 !important;
        color: white !important;
      }
      &.first {
        // border-top-left-radius: 10px !important;
        // border-bottom-left-radius: 10px !important;

        &:before {
          // background-color: #001d38;
          color: black;
          content: attr(data-price);
          // border-bottom-left-radius: 10px !important;
          // border-bottom-right-radius: 10px !important;
          // color: white;
        }

        // @each $type, $color in $first-colors{
        //     &.#{$type}{
        //         -webkit-transition: all 0.2s;
        //         -moz-transition: all 0.2s;
        //         -o-transition: all 0.2;
        //         transition: all 0.2s;
        //         background-color: $color;
        //         color: white;
        //     }
        // }
      }

      // @each $type, $color in $selected-colors{
      //     &.#{$type}{
      //         -webkit-transition: all 0.4s;
      //         -moz-transition: all 0.4s;
      //         -o-transition: all 0.4s;
      //         transition: all 0.4s;
      //         background-color: $color;
      //         color: white;
      //     }
      // }

      &.last {
        // border-top-right-radius: 10px !important;
        // border-bottom-right-radius: 10px !important;

        // @each $type, $color in $first-colors{
        //     &.#{$type}{
        //         -webkit-transition: all 0.2s;
        //         -moz-transition: all 0.2s;
        //         -o-transition: all 0.2;
        //         transition: all 0.2s;
        //         background-color: $color;
        //         color: white;
        //     }
        // }
      }

      &:before {
        color: white;
        content: "";
      }
    }
  }
}

.table-calendar {
  transition: opacity 900ms;
  will-change: opacity;
  opacity: 0;

  &.fade-in {
    opacity: 1;
  }
}
#calendar-tables-container {
  height: auto;
  @media (min-width: 1023px) {
    max-width: 100vw !important;
  }
  .width-mobile {
    @media (max-width: 1023px) {
      width: 100% !important;
    }
  }
}
.avm-btn {
  text-transform: unset;
}

table:not(.loading) {
  .today {
    font-weight: bold !important;
    color: black !important;
    border: solid 1px black;
    border-radius: 50%;
    opacity: 1 !important;
  }
}

.outgoing-text-align {
  text-align: center;

  @media screen and (min-width: 1024px) {
    text-align: left;
  }
}
</style>
